<template>
    <div class="features">
        <vue-headful :title="$t('features.meta-title')" :keywords="$t('features.meta-keywords')" :description="$t('features.meta-description')"/>

        <!-- <section class="hero is-features">
            <div class="hero-body">
                <div class="container has-text-centered">
                    <transition name="slide-down">
                        <h1 class="title is-size-3 is-unselectable is-spaced">{{ $t('features.title') }}</h1>
                    </transition>
                    <transition name="slide-up-200ms">
                        <h2 class="subtitle is-unselectable" v-html="$t('features.subtitle')"/>
                    </transition>
                </div>
            </div>
        </section> -->

        <section id="theme" class="section">
            <div class="container">
                <h4 class="title is-4 is-spaced">
                    <a class="is-anchor-link" href="#theme">#</a>
                    <span>{{ $t('features.theme.title') }}</span>
                </h4>

                <div class="content">
                    <ul>
                        <li v-html="$t('features.theme.texttheme')"/>
                    </ul>
                </div>

                <div id="onlyicon" class="has-padding-left">
                    <h5 class="title is-5 is-spaced">
                        <a class="is-anchor-link" href="#onlyicon">#</a>
                        <span>{{ $t('features.theme.onlyicon.title') }}</span>
                    </h5>

                    <div class="columns is-mobile is-multiline has-text-centered is-centered">
                        <div class="column is-narrow">
                            <figure>
                                <ResponsiveImage class="image" width="620px" height="286px" borderRadius="10px" :src="require('@/assets/media/features/Only-Icon.png')" skeleton/>

                                <figcaption v-html="$t('features.theme.onlyicon.text')"></figcaption>
                            </figure>
                        </div>
                    </div>
                </div>

                <div id="listcol" class="has-padding-left">
                    <h5 class="title is-5 is-spaced">
                        <a class="is-anchor-link" href="#listcol">#</a>
                        <span>{{ $t('features.theme.listcol.title') }}</span>
                    </h5>

                    <div class="columns is-mobile is-multiline has-text-centered is-centered">
                        <div class="column is-narrow">
                            <figure>
                                <ResponsiveImage class="image" width="620px" height="286px" borderRadius="10px" :src="require('@/assets/media/features/List-Cols.png')" skeleton/>

                                <figcaption v-html="$t('features.theme.listcol.text')"></figcaption>
                            </figure>
                        </div>
                    </div>
                </div>
               
            </div>
        </section>

        <section id="fast" class="section">
            <div class="container">
                <h4 class="title is-4 is-spaced">
                    <a class="is-anchor-link" href="#fast">#</a>
                    <span>{{ $t('features.fast.title') }}</span>
                </h4>

                <div class="content">
                    <ul>
                        <li v-html="$t('features.fast.textfast')"/>
                    </ul>
                </div>

                <div id="hardware" class="has-padding-left">
                    <h5 class="title is-5 is-spaced">
                        <a class="is-anchor-link" href="#hardware">#</a>
                        <span>{{ $t('features.fast.hardware.title') }}</span>
                    </h5>

                    <div class="columns is-mobile is-multiline has-text-centered is-centered">
                        <div class="column is-narrow">
                            <figure>
                                <ResponsiveImage class="image" width="616px" height="549px" borderRadius="10px" :src="require('@/assets/media/features/GPU-Chart.png')" skeleton/>

                                <figcaption v-html="$t('features.fast.hardware.gpu-chart')"></figcaption>
                            </figure>
                        </div>
                    </div>
                </div>

                <div id="cpu" class="has-padding-left">
                    <h5 class="title is-5 is-spaced">
                        <a class="is-anchor-link" href="#cpu">#</a>
                        <span>{{ $t('features.fast.cpu.title') }}</span>
                    </h5>

                    <div class="columns is-mobile is-multiline has-text-centered is-centered">
                        <div class="column">
                            <figure>
                                <ResponsiveImage class="image" width="616px" height="549px" borderRadius="10px" :src="require('@/assets/media/features/CPU-Coodesker.png')" skeleton/>
                                <ResponsiveImage class="image" width="616px" height="549px" borderRadius="10px" :src="require('@/assets/media/features/CPU-Explorer.png')" skeleton/>
                                <figcaption v-html="$t('features.fast.cpu.text')"></figcaption>
                            </figure>
                        </div>
                    </div>
                </div>
               
            </div>
        </section>
        
        <section id="editor" class="section">
            <div class="container">
                <h4 class="title is-4 is-spaced">
                    <a class="is-anchor-link" href="#editor">#</a>
                    <span>{{ $t('features.editor.title') }}</span>
                </h4>

                <div class="content">
                    <ul>
                        <li v-html="$t('features.editor.texteditor')"/>
                    </ul>
                </div>

                <div id="rules" class="has-padding-left">
                    <h5 class="title is-5 is-spaced">
                        <a class="is-anchor-link" href="#rules">#</a>
                        <span>{{ $t('features.editor.rules.title') }}</span>
                    </h5>

                    <div class="columns is-mobile is-multiline has-text-centered is-centered">
                        <div class="column is-narrow">
                            <figure>
                                <ResponsiveImage class="image" width="628px" height="426px" borderRadius="10px" :src="require('@/assets/media/features/Define-Rules.png')" skeleton/>

                                <figcaption v-html="$t('features.editor.rules.text')"></figcaption>
                            </figure>
                        </div>
                    </div>
                </div>

                <div id="theme" class="has-padding-left">
                    <h5 class="title is-5 is-spaced">
                        <a class="is-anchor-link" href="#theme">#</a>
                        <span>{{ $t('features.editor.theme.title') }}</span>
                    </h5>

                    <div class="columns is-mobile is-multiline has-text-centered is-centered">
                        <div class="column is-narrow">
                            <figure>
                                <ResponsiveImage class="image" width="628px" height="426px" borderRadius="10px" :src="require('@/assets/media/features/Box-Theme.png')" skeleton/>

                                <figcaption v-html="$t('features.editor.theme.text')"></figcaption>
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="folder" class="section">
            <div class="container">
                <h4 class="title is-4 is-spaced">
                    <a class="is-anchor-link" href="#folder">#</a>
                    <span>{{ $t('features.folder.title') }}</span>
                </h4>

                <div class="content">
                    <ul>
                        <li v-html="$t('features.folder.textfolder')"/>
                    </ul>
                </div>

                <div id="map" class="has-padding-left">
                    <h5 class="title is-5 is-spaced">
                        <a class="is-anchor-link" href="#map">#</a>
                        <span>{{ $t('features.folder.map.title') }}</span>
                    </h5>

                    <div class="columns is-mobile is-multiline has-text-centered is-centered">
                        <div class="column is-narrow">
                            <figure>
                                <ResponsiveImage class="image" width="620px" height="286px" borderRadius="10px" :src="require('@/assets/media/features/Map-Folder.png')" skeleton/>

                                <figcaption v-html="$t('features.folder.map.text')"></figcaption>
                            </figure>
                        </div>
                    </div>
                </div>

                <div id="organize" class="has-padding-left">
                    <h5 class="title is-5 is-spaced">
                        <a class="is-anchor-link" href="#organize">#</a>
                        <span>{{ $t('features.folder.organize.title') }}</span>
                    </h5>

                    <div class="columns is-mobile is-multiline has-text-centered is-centered">
                        <div class="column is-narrow">
                            <figure>
                                <ResponsiveImage class="image" width="620px" height="286px" borderRadius="10px" :src="require('@/assets/media/features/Map-Folder-Organize.png')" skeleton/>

                                <figcaption v-html="$t('features.folder.organize.text')"></figcaption>
                            </figure>
                        </div>
                    </div>
                </div>

                <div id="internal" class="has-padding-left">
                    <h5 class="title is-5 is-spaced">
                        <a class="is-anchor-link" href="#internal">#</a>
                        <span>{{ $t('features.folder.internal.title') }}</span>
                    </h5>

                    <div class="columns is-mobile is-multiline has-text-centered is-centered">
                        <div class="column is-narrow">
                            <figure>
                                <ResponsiveImage class="image" width="620px" height="286px" borderRadius="10px" :src="require('@/assets/media/features/Map-Folder-Internal.png')" skeleton/>

                                <figcaption v-html="$t('features.folder.internal.text')"></figcaption>
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="multi-tab" class="section">
            <div class="container">
                <h4 class="title is-4 is-spaced">
                    <a class="is-anchor-link" href="#multi-tab">#</a>
                    <span>{{ $t('features.multi-tab.title') }}</span>
                </h4>

                <div class="content">
                    <ul>
                        <li v-html="$t('features.multi-tab.textbox')"/>
                    </ul>
                </div>

                <div id="box" class="has-padding-left">
                    <h5 class="title is-5 is-spaced">
                        <a class="is-anchor-link" href="#box">#</a>
                        <span>{{ $t('features.multi-tab.box.title') }}</span>
                    </h5>

                    <div class="columns is-mobile is-multiline has-text-centered is-centered">
                        <div class="column is-narrow">
                            <figure>
                                <ResponsiveImage class="image" width="620px" height="286px" borderRadius="10px" :src="require('@/assets/media/features/Multi-Tab-Boxes.png')" skeleton/>

                                <figcaption v-html="$t('features.multi-tab.box.text')"></figcaption>
                            </figure>
                        </div>
                    </div>
                </div>

                <div id="folderbox" class="has-padding-left">
                    <h5 class="title is-5 is-spaced">
                        <a class="is-anchor-link" href="#folderbox">#</a>
                        <span>{{ $t('features.multi-tab.folderbox.title') }}</span>
                    </h5>

                    <div class="columns is-mobile is-multiline has-text-centered is-centered">
                        <div class="column is-narrow">
                            <figure>
                                <ResponsiveImage class="image" width="620px" height="286px" borderRadius="10px" :src="require('@/assets/media/features/Multi-Tab-Folder.png')" skeleton/>

                                <figcaption v-html="$t('features.multi-tab.folderbox.text')"></figcaption>
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="backup" class="section">
            <div class="container">
                <h4 class="title is-4 is-spaced">
                    <a class="is-anchor-link" href="#backup">#</a>
                    <span>{{ $t('features.backup.title') }}</span>
                </h4>

                <div class="columns is-mobile is-multiline has-text-centered is-centered">
                    <div class="column is-narrow">
                        <figure>
                            <ResponsiveImage class="image" width="628px" height="426px" borderRadius="10px" :src="require('@/assets/media/features/Backup.png')" skeleton/>

                            <figcaption v-html="$t('features.backup.textbackup')"></figcaption>
                        </figure>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
    import ResponsiveImage from "@/components/ResponsiveImage.vue";

    export default {
        components: {
            ResponsiveImage
        }
    };
</script>

<style lang="scss" scoped>
    @import "@/mixins/colors.scss";

    .is-anchor-link {
        margin-right: 0.5rem;
    }

    .hero.is-features {
        background-image: linear-gradient($home, $home-light);
    }

    figure {
        display: table;
    }

    figcaption {
        max-width: 100%;
        width: auto;
        display: table-caption;
        caption-side: bottom;
        background: white;
        margin: 0.25rem 0 1rem 0;
        border-radius: 5px;
    }

    .has-padding-left {
        padding-left: 1rem;
    }
</style>